import { Component } from "react";
import { NavLink } from "react-router-dom";

class UpdatePayrollNavigationSideBar extends Component{
    render () {
        const employee_id = this.props.employee_id;
        return <div className="col-lg-3">
        <div
          className="nav flex-column custom-nav nav-pills"
          role="tablist"
          aria-orientation="vertical"
        >
          <NavLink
            to={`/Employee/EmployeeList/${employee_id}`}
            className="nav-link d-flex justify-content-start align-items-center"
            type="button"
            role="tab"
          
          >
            <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />{" "}
            <span
              className="text-left"
              style={{
                textAlign: "left",
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Employee List
            </span>
          </NavLink>
          <NavLink
            to={`/Employee/Heads/${employee_id}`}
            className="nav-link d-flex justify-content-start align-items-center"
            type="button"
            role="tab"
          
          >
            <i
              className="ri-edit-box-line text-primary fs-20 mr-3"
              style={{ fontSize: "24px" }}
            />{" "}
            <span
              className="text-left"
              style={{
                textAlign: "left",
                marginLeft: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Heads
            </span>
          </NavLink>

         
          </div>
        {/* end nav */}
      </div>
    }
}

export default UpdatePayrollNavigationSideBar;